import { render, staticRenderFns } from "./system_mechanism_management.vue?vue&type=template&id=134501c8&scoped=true&"
import script from "./system_mechanism_management.vue?vue&type=script&lang=js&"
export * from "./system_mechanism_management.vue?vue&type=script&lang=js&"
import style0 from "./system_mechanism_management.vue?vue&type=style&index=0&id=134501c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134501c8",
  null
  
)

export default component.exports